import LandingPageFeatures from '@/app/components/LandingPage/LandingPageFeatures';

import heartHealthFeatures from '../_data/heartHealthFeatures';
import heartHealthFeaturesGradients from '../_data/heartHealthFeaturesGradients';

const HeartHealthFeatures = (): JSX.Element => {
  return (
    <LandingPageFeatures
      data-cy="heart-health-features"
      eyebrow="heart_health_features_eyebrow"
      features={heartHealthFeatures}
      imageGradientBg={{
        className: 'bg-brown-500',
        gradients: heartHealthFeaturesGradients,
      }}
      textColor="brown-600"
    />
  );
};

export default HeartHealthFeatures;
